import { BentResponse } from 'bent';
import { httpClient } from '../../../httpClient';

const CHECK_IN_SERVICE_URL = process.env.REACT_APP_CHECK_IN_SERVICE_URL;

export const getCheckInInsights = (token: string, queryParam: string) =>
  httpClient('GET', CHECK_IN_SERVICE_URL!, 200, { Authorization: `Bearer ${token}` })(
    `/check-in-insights${`?${queryParam}` ?? ''}`
  ) as Promise<BentResponse>;
